// Metz Nederland B.V. — Website data
// Bevat alleen wat nog dynamisch wordt opgehaald uit pagina's.
// Pagina-content staat per pagina inline (Home, OverOns, Werkwijze, DaaromMetz, etc.)

const BASE_URL = process.env.PUBLIC_URL || '';
const imageUrl = (path) => `${BASE_URL}${path}`;

export const siteData = {
  company: {
    name: 'Metz Nederland B.V.',
    shortName: 'Metz Nederland',
    tagline: 'Bouwen en mensen verbinden',
    description:
      'Metz Nederland is een flexibel bouw- en aannemersbedrijf met een persoonlijke en betrokken aanpak. Sinds 1999 werken wij voor woningcorporaties, zorginstellingen, ziekenhuizen, VvE’s en gemeenten.',
    location: {
      street: 'Cornelis Houtmanstraat 9',
      city: '3124 LB Schiedam',
      country: 'Nederland'
    },
    contact: {
      phone: '010 471 81 10',
      phoneRaw: '+31104718110',
      email: 'info@metz-nederland.nl',
      kvk: '24294561'
    }
  },

  // Projecten worden getoond op /projecten en /projecten/:slug.
  // Voorbeeldstructuur per project:
  // {
  //   id: 1,
  //   title: 'Renovatie Erasmus MC',
  //   slug: 'renovatie-erasmus-mc',
  //   excerpt: 'Korte beschrijving in 1-2 zinnen.',
  //   content: 'Volledige tekst over het project.',
  //   image: imageUrl('/images/jouw-project-foto.jpg'),    // thumbnail op /projecten
  //   gallery: [imageUrl('/images/foto-1.jpg'), ...]        // optioneel: meerdere foto's op de detailpagina
  // }
  projects: [
    {
      id: 1,
      title: 'Diergaarde Blijdorp, Rotterdam',
      slug: 'diergaarde-blijdorp',
      excerpt:
        'Verbouwings- en onderhoudswerkzaamheden in een volop bezochte omgeving, uitgevoerd met oog voor dier, bezoeker en medewerker.',
      // TODO: definitieve projecttekst wordt later door Metz zelf aangeleverd.
      content:
        'Voor Diergaarde Blijdorp in Rotterdam voerden wij uiteenlopende verbouwings- en onderhoudswerkzaamheden uit, midden in een park dat dagelijks duizenden bezoekers ontvangt. Juist die context maakt dit project typisch Metz: werken in een omgeving die volop in gebruik is, vraagt om een zorgvuldige voorbereiding en een strakke planning.\n\nVan de eerste inventarisatie tot de oplevering stond het beperken van overlast centraal. We stemden de werkzaamheden nauwkeurig af op de openingstijden en de routes van bezoekers, hielden rekening met de rust van de dieren en zorgden dat het park altijd veilig toegankelijk bleef. Door korte lijnen met de opdrachtgever en een hechte samenwerking met leveranciers en onderaannemers konden we flexibel inspelen op de dagelijkse gang van zaken in de dierentuin.\n\nHet resultaat: kwalitatief hoogwaardig werk, opgeleverd met minimale hinder voor mens en dier. Een project waarin onze kernwaarden duidelijk zichtbaar zijn: zorg, aandacht en samenwerken als één team.',
      image: imageUrl('/images/blijdorp-1.jpg'),
      gallery: [
        imageUrl('/images/blijdorp-1.jpg'),
        imageUrl('/images/blijdorp-2.jpg'),
        imageUrl('/images/blijdorp-3.jpg')
      ]
    },
    {
      id: 2,
      title: 'Vlietland Ziekenhuis, Schiedam',
      slug: 'onderhoud-vlietland-ziekenhuis',
      excerpt:
        'Onderhouds- en renovatiewerkzaamheden in een volop draaiend zorgcentrum, uitgevoerd met minimale hinder voor patiënten, bezoekers en zorgpersoneel.',
      content:
        'Voor het Vlietland Ziekenhuis in Schiedam verzorgen wij uiteenlopende onderhouds- en renovatiewerkzaamheden, midden in een zorgomgeving die dag en nacht in bedrijf is. Juist die context maakt dit een typisch Metz-project: werken in een gebouw waar de zorg altijd doorgaat, vraagt om een zorgvuldige voorbereiding, korte lijnen en een strakke planning.\n\nVan de eerste opname tot de oplevering staat het beperken van overlast centraal. We stemmen de werkzaamheden nauwkeurig af op de roosters en routes binnen het ziekenhuis, houden rekening met de rust en veiligheid van patiënten en zorgmedewerkers en zorgen dat afdelingen en looproutes veilig toegankelijk blijven. Door nauw samen te werken met de technische dienst en facilitaire afdeling kunnen we flexibel inspelen op de dagelijkse gang van zaken in het zorgcentrum.\n\nHet resultaat: kwalitatief hoogwaardig werk, opgeleverd met zo min mogelijk hinder voor mens en zorgproces. Een project waarin onze kernwaarden duidelijk zichtbaar zijn: zorg, aandacht en samenwerken als één team.',
      image: imageUrl('/images/metz-bus-vlietland.jpg'),
      gallery: [
        imageUrl('/images/metz-bus-vlietland.jpg'),
        imageUrl('/images/project-vlietland-1.jpg'),
        imageUrl('/images/project-vlietland-2.jpg')
      ]
    },
    {
      id: 3,
      title: 'Franciscus Gasthuis, Rotterdam',
      slug: 'franciscus-gasthuis',
      excerpt:
        'Een complete vernieuwing van de CSRD-ruimte in het bestaande gebouw van Franciscus Gasthuis, opgeknapt en naar een hoger niveau getild dankzij een sterke samenwerking tussen alle betrokken partijen.',
      content:
        'Met trots kijken we terug op een prachtig project in het bestaande gebouw van Franciscus Gasthuis, waar we de volledige CSRD-ruimte hebben vernieuwd, opgeknapt en naar een hoger niveau getild. Een resultaat dat alleen mogelijk was dankzij de sterke samenwerking tussen alle betrokken partijen.\n\nOmdat het gebouw tijdens de werkzaamheden gewoon in gebruik bleef, vroeg dit project om een zorgvuldige voorbereiding en een strakke afstemming. We stemden de planning nauwkeurig af op de dagelijkse gang van zaken en zorgden dat de overlast voor de omgeving tot een minimum beperkt bleef. Van de eerste voorbereiding tot de oplevering stond een hoogwaardig eindresultaat voorop.\n\nWat hebben we vernieuwd?\n\n- Nieuwe vloeren geplaatst\n\n- Oude wasmachines afgevoerd\n\n- Sparingen en wanden gebouwd voor de nieuwe machineopstelling\n\n- Een compleet nieuw systeemplafond aangebracht\n\n- De gevel opnieuw geschilderd\n\nHet resultaat is een volledig vernieuwde, toekomstbestendige ruimte die klaar is voor jaren intensief gebruik. Een project waarin onze kernwaarden duidelijk zichtbaar zijn: vakmanschap, aandacht en samenwerken als één team.',
      image: imageUrl('/images/franciscus-gasthuis-1.jpg'),
      gallery: [
        imageUrl('/images/franciscus-gasthuis-1.jpg'),
        imageUrl('/images/franciscus-gasthuis-2.jpg'),
        imageUrl('/images/franciscus-gasthuis-3.jpg')
      ]
    }
  ],

  // Vacatures — voeg hier openstaande functies toe.
  // - `title` verschijnt automatisch in de keuzelijst op /solliciteren én als kop op /werken-bij.
  // - `intro` is de korte tekst bovenaan de vacaturekaart.
  // - `sections` is de volledige vacaturetekst; elke sectie heeft een `heading` en
  //   optioneel `paragraphs` (array tekst) en/of `list` (array bullets) en `subheading`.
  // - `image` is de foto op de kaart; `contact` toont de HR-contactgegevens onderaan.
  // Vanuit een vacature link je naar: /solliciteren?functie=<title>
  vacancies: [
    {
      id: 1,
      title: 'Werkvoorbereider/Calculator',
      slug: 'werkvoorbereider-calculator',
      type: 'Fulltime',
      intro:
        'Metz Nederland is een betrokken bouwbedrijf dat zich bezighoudt met renovatie en onderhoud voor woningcorporaties en zorginstellingen. Wij onderscheiden ons door van een idee of vraag, een project te maken. Samenwerken, assertiviteit, communicatie en flexibiliteit zijn belangrijke kernwaarden.',
      excerpt:
        'Jij bent de spil tussen aanvraag en uitvoering: werk opnemen, calculeren en tot in de puntjes voorbereiden voor onderhouds- en renovatieprojecten.',
      image: imageUrl('/images/vacature-werkvoorbereider-calculator.jpg'),
      pdf: imageUrl('/vacatures/werkvoorbereider-calculator.pdf'),
      sections: [
        {
          heading: 'Algemene karakterisering',
          paragraphs: [
            'Als werkvoorbereider/calculator speel je een cruciale rol in het succesvol realiseren van diverse bouwkundige onderhouds- en renovatieprojecten. Je vormt de spil tussen de aanvraag van de opdrachtgever en de daadwerkelijke uitvoering van het werk. Je bent verantwoordelijk voor het zorgvuldig opnemen, calculeren én voorbereiden van zowel kleine als grote projecten.',
            'In deze veelzijdige rol beoordeel je aanvragen op haalbaarheid, stel je kostprijsbegrotingen op en bereid je het werk voor tot in de puntjes. Je schakelt dagelijks met collega’s van uitvoering en projectleiding, zorgt voor een nauwkeurige planning, maakt werkplannen en stelt waar nodig tekeningen op. Ook verzorg je de inkoop van materialen en diensten en draag je zorg voor een vlotte overdracht naar de uitvoering.',
            'Je werkt regelmatig op locatie, in een omgeving waar vaak extra aandacht is voor veiligheid, continuïteit en samenwerking met andere belanghebbenden, zoals opdrachtgevers, beheerders en gebruikers van het pand. Goede communicatie en het vermogen om mee te denken met de klant zijn in deze functie essentieel.'
          ]
        },
        {
          heading: 'Taken en verantwoordelijkheden',
          list: [
            'Opnemen van werken op locatie en beoordelen van de technische haalbaarheid',
            'Opstellen van calculaties en offertes voor bouwkundig onderhoud en renovatieprojecten',
            'Uitwerken van werkplannen, materiaallijsten, tekeningen en planningen',
            'Aanvragen en beoordelen van offertes van leveranciers en onderaannemers',
            'Verzorgen van inkoop en afstemming met de uitvoering',
            'Zorgdragen voor een goede projectoverdracht richting uitvoeringsteam',
            'Onderhouden van contact met opdrachtgevers, beheerders en andere betrokken partijen',
            'Signaleren van meer- of minderwerk en verzorgen van de bijbehorende afhandeling',
            'Bewaken van budgetten, planning en kwaliteit tijdens de voorbereidingsfase'
          ]
        },
        {
          heading: 'Functie-eisen',
          subheading: 'Opleiding, ervaring en persoonlijke vaardigheden',
          list: [
            'Mbo werk- en denkniveau bouwkunde',
            'Enkele jaren ervaring in een soortgelijke functie als werkvoorbereider en/of calculator, bij voorkeur in renovatie- en onderhoudswerkzaamheden',
            'Goede communicatieve en organisatorische vaardigheden',
            'Oog voor detail, nauwkeurigheid en verantwoordelijkheidsgevoel',
            'Proactieve en flexibele werkhouding',
            'Vermogen om zelfstandig te werken en tegelijkertijd goed te kunnen schakelen binnen een team',
            'Bereidheid om je te blijven ontwikkelen en mee te denken over verbeteringen in het werkproces'
          ]
        },
        {
          heading: 'Dit krijg je bij ons',
          list: [
            'Aantrekkelijk salaris en secundaire arbeidsvoorwaarden conform CAO Bouw en Infra',
            'Een mobiele telefoon en laptop van de zaak',
            'Opleidingsmogelijkheden voor persoonlijke ontwikkeling',
            'Een uitdagende functie met vrijheid en verantwoordelijkheid',
            'Een gedreven, betrokken en enthousiast team van collega’s in een familiebedrijf'
          ]
        }
      ],
      contact: {
        name: 'Anne Spits',
        role: 'HR Officer',
        email: 'A.Spits@metz-nederland.nl'
      }
    },
    {
      id: 2,
      title: 'Timmerman/-vrouw',
      slug: 'timmerman',
      type: 'Fulltime',
      intro:
        'Metz Nederland is een betrokken bouwbedrijf dat zich bezighoudt met renovatie en onderhoud voor woningcorporaties en zorginstellingen. Wij onderscheiden ons door van een idee of vraag, een project te maken. Samenwerken, assertiviteit, communicatie en flexibiliteit zijn belangrijke kernwaarden.',
      excerpt:
        'Lever vakmanschap op afwisselende onderhouds- en renovatieprojecten en wees het visitekaartje van Metz. Ervaren of leergierig: beiden welkom.',
      image: imageUrl('/images/vacature-timmerman.jpg'),
      pdf: imageUrl('/vacatures/timmerman.pdf'),
      sections: [
        {
          heading: 'Algemene karakterisering',
          paragraphs: [
            'Als (ervaren) timmerman/-vrouw wil je graag vakmanschap leveren. Bij onze onderhouds- en renovatieprojecten hebben wij vaklieden/timmerlieden nodig die graag kwaliteit leveren en het visitekaartje van Metz willen zijn. De werkzaamheden zijn zeer divers en soms moet rekening gehouden worden met bewoners en/of cliënten. Een duidelijke en fijne manier van communiceren is van belang. Je werkt in een fijn team en wordt aangestuurd door een uitvoerder, maar soms zul je ook zelfstandig een klus moeten klaren. Wanneer vakmanschap bij jou hoog in het vaandel zit of jij iemand bent die het timmeren graag wilt leren, neem dan contact op voor een lekkere kop koffie en goed gesprek.'
          ]
        },
        {
          heading: 'Functie-eisen',
          list: [
            'MBO Bouwkunde, niveau 2, Timmerman/-vrouw of je hebt relevante werkervaring (5 jaar)',
            'Je kunt goed zelfstandig werken en toont daarbij ook initiatief',
            'Je bent communicatief vaardig en het is voor jou een feestje om, samen met je collega’s, het werk kwalitatief goed af te leveren',
            'Je bent in het bezit van VCA Basis/VOL of je bent bereid dit te behalen'
          ]
        },
        {
          heading: 'Overige vereisten',
          list: [
            'Bereidheid tot werken op verschillende locaties'
          ]
        },
        {
          heading: 'Dit krijg je bij ons',
          list: [
            'Aantrekkelijk salaris en secundaire arbeidsvoorwaarden conform CAO Bouw en Infra',
            'Een degelijke bedrijfsbus, mobiele telefoon en laptop van de zaak',
            'Opleidingsmogelijkheden voor persoonlijke ontwikkeling',
            'Een uitdagende functie met vrijheid en verantwoordelijkheid',
            'Een gedreven, betrokken en enthousiast team van collega’s in een familiebedrijf'
          ]
        }
      ],
      contact: {
        name: 'Anne Spits',
        role: 'HR Officer',
        email: 'A.Spits@metz-nederland.nl'
      }
    },
    {
      id: 3,
      title: 'Projectcoördinator Healthcare',
      slug: 'projectcoordinator-healthcare',
      type: 'Fulltime',
      intro:
        'Metz Nederland is een betrokken bouwbedrijf dat zich bezighoudt met renovatie en onderhoud voor woningcorporaties en zorginstellingen. Wij onderscheiden ons door van een idee of vraag, een project te maken. Samenwerken, assertiviteit, communicatie en flexibiliteit zijn belangrijke kernwaarden.',
      excerpt:
        'Coördineer bouw-, renovatie- en onderhoudsprojecten in operationele zorgomgevingen, van voorbereiding tot oplevering, met minimale hinder voor de zorg.',
      image: imageUrl('/images/vacature-projectcoordinator-healthcare.jpg'),
      pdf: imageUrl('/vacatures/projectcoordinator-healthcare.pdf'),
      sections: [
        {
          heading: 'Algemene karakterisering',
          paragraphs: [
            'De projectcoördinator healthcare is verantwoordelijk voor de volledige projectcoördinatie van bouw-, renovatie-, onderhouds- en verbouwprojecten in operationele zorgomgevingen. Dit betreft met name opdrachten voor zorginstellingen. De projectcoördinator healthcare zorgt voor een efficiënte, tijdige en kwalitatieve uitvoering van meerdere projecten, binnen de gestelde kaders van de planning, budget en veiligheid. Daarnaast is de projectcoördinator healthcare een cruciale schakel in de communicatie tussen zorgorganisaties, medische gebruikers, uitvoeringsteam en onderaannemers.'
          ]
        },
        {
          heading: 'Projectvoorbereiding',
          list: [
            'Analyseren van klantvraag en projectdocumentatie',
            'Opstellen van projectplannen inclusief planning, begroting, fasering en risicobeheersing',
            'Selecteren en contracteren van onderaannemers en leveranciers',
            'Coördineren met interne teams zoals werkvoorbereiding, calculatie en uitvoering'
          ]
        },
        {
          heading: 'Projectuitvoering',
          list: [
            'Aansturen van het projectteam (werkvoorbereiders, uitvoerders, onderaannemers)',
            'Bewaken van voortgang, kwaliteit, kosten, veiligheid, continuïteit van zorgprocessen en minimale hinder voor patiënten en zorgmedewerkers',
            'Organiseren en leiden van bouwvergaderingen en werkbesprekingen',
            'Fungeren als eerste aanspreekpunt voor opdrachtgevers en stakeholders',
            'Tijdig signaleren van knelpunten en aandragen van oplossingsrichtingen'
          ]
        },
        {
          heading: 'Projectafronding',
          list: [
            'Zorgen voor een correcte en volledige oplevering van projecten',
            'Evalueren van projecten op basis van kwaliteit, planning en samenwerking',
            'Vastleggen van projectresultaten en leerpunten voor toekomstige projecten'
          ]
        },
        {
          heading: 'Overige taken',
          paragraphs: [
            'Bovengenoemde punten worden in samenspraak gedaan met de direct leidinggevende (bedrijfsleider of projectleider).'
          ],
          list: [
            'Besluitvorming over operationele zaken binnen het project',
            'Selecteren en aansturen van onderaannemers',
            'Advies geven aan directie over projectinrichting en procesverbetering',
            'Budgetbewaking binnen het kader van goedgekeurde projectplannen'
          ]
        },
        {
          heading: 'Functie-eisen',
          list: [
            'Hbo werk- en denkniveau (bouwkunde of vergelijkbaar is een pré)',
            'Minimaal 3-5 jaar ervaring in projecten of in een vergelijkbare functie in de bouwsector',
            'Aantoonbare ervaring in de bouwsector met renovatie- en onderhoudsprojecten',
            'In bezit van rijbewijs B',
            'VCA-VOL'
          ]
        },
        {
          heading: 'Vakkennis & technische vaardigheden',
          list: [
            'Kennis van wet- en regelgeving zoals milieueisen, veiligheidsregels en VCA-richtlijnen',
            'Ervaring met aanbestedingsprocedures, projectcontracten en juridische regels',
            'Bekendheid met projectbeheersystemen',
            'Digitaal vaardig met MS Office, in het bijzonder MS Excel'
          ]
        },
        {
          heading: 'Persoonlijke vaardigheden',
          list: [
            'Communicatief sterk in het aansturen van teams en motiveren van medewerkers',
            'Organisatorisch talent: structureren en monitoren van processen en deadlines',
            'Probleemoplossend vermogen en besluitvaardigheid: snel kunnen schakelen met alle betrokken partijen bij verstoringen of technische issues',
            'Besluitvaardig: krachtig besluiten nemen op basis van feiten en ervaring',
            'Klantgericht: begrijpen van klantbehoeften en verwachtingen managen'
          ]
        },
        {
          heading: 'Overige vereisten',
          list: [
            'Bereidheid tot werken op diverse zorglocaties en in operationele zorgomgevingen'
          ]
        },
        {
          heading: 'Dit krijg je bij ons',
          list: [
            'Aantrekkelijk salaris en secundaire arbeidsvoorwaarden conform CAO Bouw en Infra',
            'Een degelijke auto, mobiele telefoon en laptop van de zaak',
            'Opleidingsmogelijkheden voor persoonlijke ontwikkeling',
            'Een uitdagende functie met vrijheid en verantwoordelijkheid',
            'Een gedreven, betrokken en enthousiast team van collega’s in een familiebedrijf'
          ]
        }
      ],
      contact: {
        name: 'Anne Spits',
        role: 'HR Officer',
        email: 'A.Spits@metz-nederland.nl'
      }
    },
    {
      id: 4,
      title: 'Uitvoerder',
      slug: 'uitvoerder',
      type: 'Fulltime',
      intro:
        'Metz Nederland is een betrokken bouwbedrijf dat zich bezighoudt met renovatie en onderhoud voor woningcorporaties en zorginstellingen. Wij onderscheiden ons door van een idee of vraag, een project te maken. Samenwerken, assertiviteit, communicatie en flexibiliteit zijn belangrijke kernwaarden.',
      excerpt:
        'Stuur de dagelijkse gang van zaken op de bouwplaats aan en houd grip op planning, kwaliteit, kosten en veiligheid. De schakel tussen kantoor en uitvoering.',
      image: imageUrl('/images/vacature-uitvoerder.jpg'),
      pdf: imageUrl('/vacatures/uitvoerder.pdf'),
      sections: [
        {
          heading: 'Algemene karakterisering',
          paragraphs: [
            'De kerntaken van een uitvoerder in de bouwsector draaien om het organiseren, aansturen en bewaken van de dagelijkse werkzaamheden op een bouwproject. Een uitvoerder is de schakel tussen kantoor (projectleiding/werkvoorbereiding) en de bouwplaats.',
            'Een goede uitvoerder is naast technisch onderlegd ook communicatief sterk, stressbestendig en organisatorisch vaardig. Deze rol vraagt om overzicht, daadkracht en flexibiliteit.'
          ]
        },
        {
          heading: 'Organisatie & coördinatie op de bouwplaats',
          list: [
            'Dagelijkse leiding op de bouwlocatie',
            'Opstellen van werk- en dagplanningen',
            'Zorgen voor een veilige, ordelijke en efficiënte bouwplaats',
            'Aansturen van eigen vaklieden, onderaannemers en leveranciers'
          ]
        },
        {
          heading: 'Inkoop & logistiek',
          list: [
            'Tijdig bestellen van materialen en materieel',
            'Afstemmen van leveringen met de voortgang van het werk',
            'Bewaken van opslag en verwerking van materialen op locatie'
          ]
        },
        {
          heading: 'Planning en tijdsbeheer',
          list: [
            'Bewaken van de voortgang ten opzichte van de projectplanning',
            'Signaleren en oplossen van vertragingen of knelpunten',
            'Rapporteren van voortgang aan projectleider of opdrachtgever'
          ]
        },
        {
          heading: 'Kostenbewaking & budgetbeheer',
          list: [
            'Controleren en beheren van het projectbudget op uitvoeringsniveau',
            'Voorkomen van faalkosten en verspilling',
            'Terugkoppelen van financiële afwijkingen'
          ]
        },
        {
          heading: 'Kwaliteit & veiligheid',
          list: [
            'Toezien op naleving van kwaliteitsnormen en veiligheidseisen',
            'Uitvoeren van veiligheidsrondes en toolboxmeetings',
            'Signaleren van risico’s en nemen van corrigerende maatregelen'
          ]
        },
        {
          heading: 'Communicatie & overleg',
          list: [
            'Contact onderhouden met projectleiding, werkvoorbereiding en onderaannemers',
            'Aanspreekpunt voor bewoners, opdrachtgevers en inspecteurs bij renovatie- en onderhoudsprojecten',
            'Deelnemen aan bouwvergaderingen en rapporteren van knelpunten'
          ]
        },
        {
          heading: 'Administratie & rapportage',
          list: [
            'Bijhouden van dagrapporten en weekrapportages',
            'Registratie van uren, materiaalgebruik en afwijkingen',
            'Voorbereiden van opleverdossiers'
          ]
        },
        {
          heading: 'Functie-eisen',
          subheading: 'Opleiding & ervaring',
          list: [
            'MBO-4 diploma Bouwkunde of vergelijkbare richting',
            'Enkele jaren ervaring als uitvoerder of in een vergelijkbare rol binnen de bouw (bijvoorbeeld voorman of assistent-uitvoerder)',
            'Kennis van renovatie en onderhoud'
          ]
        },
        {
          heading: 'Vakkennis & technische vaardigheden',
          list: [
            'Goede kennis van bouwprocessen, technieken en materialen',
            'Inzicht in bouwvoorschriften, veiligheidsnormen (zoals VCA) en kwaliteitseisen',
            'Bekendheid met bestekken, tekeningen en planningssoftware',
            'Ervaring met inkoop van materialen en aansturing van onderaannemers'
          ]
        },
        {
          heading: 'Persoonlijke vaardigheden',
          list: [
            'Communicatief sterk (zowel mondeling als schriftelijk)',
            'Organisatorisch talent: goed in plannen, aansturen en coördineren',
            'Probleemoplossend vermogen en besluitvaardigheid',
            'Stressbestendig: kan omgaan met deadlines en onverwachte situaties',
            'Klantgericht, belangrijk bij renovatieprojecten met bewoners of eindgebruikers',
            'Teamspeler die graag initiatief neemt en praktisch meedenkt'
          ]
        },
        {
          heading: 'Overige vereisten',
          list: [
            'In het bezit van een geldig VCA-VOL certificaat (of bereid dit te halen)',
            'Rijbewijs B',
            'Bereidheid tot werken op verschillende locaties en incidenteel buiten reguliere werktijden (afhankelijk van het project). Locaties kunnen variëren binnen de regio’s Rotterdam, Utrecht en Amsterdam.'
          ]
        },
        {
          heading: 'Dit krijg je bij ons',
          list: [
            'Aantrekkelijk salaris en secundaire arbeidsvoorwaarden conform CAO Bouw en Infra',
            'Een degelijke auto, mobiele telefoon en laptop van de zaak',
            'Opleidingsmogelijkheden voor persoonlijke ontwikkeling',
            'Een uitdagende functie met vrijheid en verantwoordelijkheid',
            'Een gedreven, betrokken en enthousiast team van collega’s in een familiebedrijf'
          ]
        }
      ],
      contact: {
        name: 'Anne Spits',
        role: 'HR Officer',
        email: 'A.Spits@metz-nederland.nl'
      }
    }
  ]
};

export { imageUrl };
